import React, { Component } from 'react';
import { Slider } from 'antd';
import Icon from 'components/Icon';

import { 
	mathMultiply,
} from '@/utils/common';
import './style/index.less';

export default class PlaylistSlider extends Component {
	constructor() {
		super();
		this.init = {
			left: 30,
			top: 30,
		}
		this.offset = {
			left: 20,
			top: 270,
		}
		this.state = {
			startX: 0,
			startY: 0,
			left: 0,
			top: 0,
		}
	}

	componentDidMount(){
		const {
			centerareawidth,
      		centerareaheight,
		} = this.props;
		this.setState({
			left: centerareawidth - this.init.left - this.offset.left,
			top: centerareaheight - this.init.top - this.offset.top,
		})
		document.addEventListener('mouseup', this.onMouseUp);
	}

	componentWillUnmount() {
		document.removeEventListener('mouseup', this.onMouseUp);
	}
	// 获取鼠标点击title时的坐标、title的坐标以及两者的位移
	getPosition = (e) => {
		// 鼠标点击的坐标
		let mouseX = 0, mouseY = 0;
		if (e.pageX || e.pageY) {  //ff,chrome等浏览器
		  mouseX = e.pageX;
		  mouseY = e.pageY;
		} else {
		  mouseX = e.clientX + document.body.scrollLeft - document.body.clientLeft;
		  mouseY = e.clientY + document.body.scrollTop - document.body.clientTop;
		}
		return {positionX: mouseX, positionY:mouseY}
	}
	  
	/**
	 * 鼠标按下，设置modal状态为可移动，并注册鼠标移动事件
	 * 计算鼠标按下时，指针所在位置与modal位置以及两者的差值
	 **/
	onMouseDown = (event) => {
		event.stopPropagation();//不可以取消，影响resize
    	event.preventDefault();
		const position = this.getPosition(event);
		window.onmousemove = this.onMouseMove;
		this.setState({moving: true, startX: position.positionX, startY: position.positionY});
	}
	
	// 松开鼠标，设置modal状态为不可移动,
	onMouseUp = (event) => {
		// event.stopPropagation();//不可以取消，影响resize//影响颜色选择的mouseup
    	// event.preventDefault();
		this.offset.left = this.state.left;
		this.offset.top = this.state.top;
		this.setState({moving: false});
	}
	
	// 鼠标移动重新设置modal的位置
	onMouseMove = (event) => {
		event.stopPropagation();//不可以取消，影响resize
    	event.preventDefault();
		let {moving, left, top,} = this.state;
		if (moving) {
			const {
				centerareawidth,
				  centerareaheight,
			} = this.props;
			// let {
			// 	scrollLeft,
			// 	scrollTop,
			// } = document.querySelector(".playlist-workarea");
			// 获取鼠标位置数据
			const position = this.getPosition(event);
			
			// left = position.positionX + scrollLeft - 79 - 254 - 10 - 15;
			// top = position.positionY + scrollTop - 78 - 10 - 240 - 5;
			left = position.positionX - 254 - 10 - 15;
			top = position.positionY - 10 - 240 - 5;
			if(left < 30) {
				left = 30;
			}
			if(top < 30) {
				top = 30;
			}
			if(left > centerareawidth - 60 + 200) {
				left = centerareawidth - 60 + 200;
			}
			if(top > centerareaheight - 296 + 120) {
				top = centerareaheight - 296 + 120;
			}
			this.setState({left, top});
		}
	}
	
	render() {
		const {
			left,
			top,
		} = this.state;
		const {
			divcompare,
			changeCompare,
			playlistSceneDefaultWidth,
		} = this.props;
		
		const sliderProps = {
			// left: playlistSceneWidth === 0 ? left : left + playlistSceneDefaultWidth,
			left: left + playlistSceneDefaultWidth,
			top,
		}
		return (
			<div className={"playlist-workarea-slider"} style={{...sliderProps}}>
				<div className={"playlist-workarea-slider-max"}
					title={window.language['playlist.amplification']}
					onClick={(value) => {
						changeCompare('big');
					}}>
					<Icon className="add-circle-o" />
				</div>
				<Slider vertical tooltipVisible 
					min={20}
					max={200}
					marks={{100:'100'}}
					onChange={(value) => {
						changeCompare(value);
					}} value={mathMultiply(divcompare, 100)} />
				<div className={"playlist-workarea-slider-min"}
					title={window.language['playlist.narrow']}
					onClick={(value) => {
						changeCompare('small');
					}}>
					<Icon className="minus-circle-o" />
				</div>
				<div className={"playlist-workarea-slider-move"} 
					title={window.language['playlist.move']}
					onMouseDown={this.onMouseDown}
					onMouseUp={this.onMouseUp}
				>
					<Icon className="move-o" />
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Playlist/PlaylistSlider.js